import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BadgeComponent } from '../../badge/badge.component';
import { BadgeColor } from '../../badge/badge.types';
import { DotComponent } from '../../dot/dot.component';

@Component({
  selector: 'rt-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled',
  },
  imports: [DotComponent, BadgeComponent],
})
export class TabComponent {
  @Input() public isUnread: boolean = false;
  @Input() public count: number | string = 0;
  @Input() public countColor: BadgeColor = 'counter-default';
  @Input() public href: string;
  @Input() public hrefTarget: string;
  @Input() public disabled: boolean = false;
  @Input() public noRightPadding: boolean = false;
}
